import { render, staticRenderFns } from "./NewPlan_Details.vue?vue&type=template&id=4871ed55&scoped=true"
import script from "./NewPlan_Details.vue?vue&type=script&lang=js"
export * from "./NewPlan_Details.vue?vue&type=script&lang=js"
import style0 from "./NewPlan_Details.vue?vue&type=style&index=0&id=4871ed55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871ed55",
  null
  
)

export default component.exports